"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function setOriginalTarget(decoratedTarget, originalTarget) {
    decoratedTarget.__SATCHELJS_ORIGINAL_TARGET = originalTarget;
}
exports.setOriginalTarget = setOriginalTarget;
function getOriginalTarget(decoratedTarget) {
    if (typeof decoratedTarget.__SATCHELJS_ORIGINAL_TARGET !== typeof undefined) {
        return decoratedTarget.__SATCHELJS_ORIGINAL_TARGET;
    }
    return undefined;
}
exports.getOriginalTarget = getOriginalTarget;
function setActionType(decoratedTarget, actionType) {
    decoratedTarget.__SATCHELJS_ACTION_TYPE = actionType;
}
exports.setActionType = setActionType;
function getActionType(decoratedTarget) {
    return decoratedTarget.__SATCHELJS_ACTION_TYPE;
}
exports.getActionType = getActionType;
